import { Minus, Plus } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from 'shared-ui';

interface MapZoomControlProps {
    onZoomIn: () => void;
    onZoomOut: () => void;
}

export function MapZoomControl({ onZoomIn, onZoomOut }: MapZoomControlProps) {
    return (
        <div className="border-border bg-background w-10 overflow-hidden rounded-md border shadow-sm">
            <Tooltip>
                <TooltipTrigger
                    render={
                        <button
                            type="button"
                            aria-label="Zoom In"
                            onClick={onZoomIn}
                            className="hover:bg-accent hover:text-accent-foreground focus-visible:ring-origin-blue/50 flex h-10 w-full cursor-pointer items-center justify-center transition-colors focus-visible:ring-3 focus-visible:outline-none focus-visible:ring-inset"
                        >
                            <Plus className="text-origin-blue size-4" />
                        </button>
                    }
                />
                <TooltipContent side="left">Zoom In</TooltipContent>
            </Tooltip>
            <div className="bg-border h-px" aria-hidden />
            <Tooltip>
                <TooltipTrigger
                    render={
                        <button
                            type="button"
                            aria-label="Zoom Out"
                            onClick={onZoomOut}
                            className="hover:bg-accent hover:text-accent-foreground focus-visible:ring-origin-blue/50 flex h-10 w-full cursor-pointer items-center justify-center transition-colors focus-visible:ring-3 focus-visible:outline-none focus-visible:ring-inset"
                        >
                            <Minus className="text-origin-blue size-4" />
                        </button>
                    }
                />
                <TooltipContent side="left">Zoom Out</TooltipContent>
            </Tooltip>
        </div>
    );
}
